// extracted by mini-css-extract-plugin
export var actionButton = "_o8-0";
export var actionMenuContainer = "_o8-i";
export var bubble = "_o8-2";
export var bubbleActionMenu = "_o8-j";
export var bubbleContext = "_o8-6";
export var bubbleItems = "_o8-7";
export var customer = "_o8-3";
export var divider = "_o8-8";
export var fileList = "_o8-9";
export var hiddenComment = "_o8-o";
export var infoAbove = "_o8-a";
export var internal = "_o8-4";
export var lightActionButton = "_o8-1";
export var link = "_o8-b";
export var merchant = "_o8-5";
export var message = "_o8-c";
export var profilePicture = "_o8-e";
export var quillToolbarContainer = "_o8-f";
export var senderDate = "_o8-g";
export var senderDateCustomer = "_o8-h";
export var senderName = "_o8-d";
export var time = "_o8-k";
export var uploadedImage = "_o8-l";
export var username = "_o8-m";
export var xsmall = "_o8-n";